// Module
var code = `<button class="p-2 h-10" aria-label="Toggle theme between light and dark mode"> <i class="fas fa-sun text-yellow-500 dark:hidden"></i> <i class="fas fa-moon text-blue-300 hidden dark:block"></i> </button> `;
// Exports
export default code;